import { Message, Loading, MessageBox } from 'element-ui'

const eleui = {
    alert: (msg, msgtype = 'error', duration = 3) => Message({
        showClose: true,
        center: true,
        offset: 50,
        message: decodeURIComponent(msg),
        type: msgtype,
        duration: duration * 1000,
        customClass: 'messagezindex',
        dangerouslyUseHTMLString: true
    }),
    loading: (text) => {
        if (text != '') {
            return Loading.service({
                lock: true,
                text: text,
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.3)',
                customClass: 'loadingtop'
            });
        }
        else {
            return '';
        }
    },
    loadingclose: (obj) => {
        if (obj != '') {
            obj.close();
        }
    },
    confirm: (msg, callbackyes, callbackno, title = '提示', btnyes = '确定', btnno = '取消') => {
        MessageBox.confirm(msg, title, {
            confirmButtonText: btnyes,
            cancelButtonText: btnno,
            type: 'warning'
        }).then(() => {
            callbackyes();
        }).catch(() => {
            if (callbackno != undefined) {
                callbackno();
            }
        });
    }
}

export default eleui
